const POSITION_PATTERN = /\[(\d+)\]/g;

/**
 * The positions an instance path walks through: `items[2].sub[1]` → `[2, 1]`; an empty or absent path →
 * `[]`. The only reader of instance paths on the front: it never looks at segment names.
 */
const parseInstancePositions = (path: string | undefined): readonly number[] => {
	if (path === undefined || path === '') {
		return [];
	}

	return Array.from(path.matchAll(POSITION_PATTERN), (match) => Number(match[1]));
};

export default parseInstancePositions;
